import { UsernameField } from "@/components/authentication/UsernameField";
import supabase from "@/features/supabase";
import { useKeys } from "@/utils/hooks/useKeys";
import { LockOutlined, UnlockOutlined } from "@ant-design/icons";
import { useSession } from "@supabase/auth-helpers-react";
import { Button, Form, Input, Skeleton } from "antd";
import { useState } from "react";
const UserPasswordInput = ({
  prompt = "Your secure files are locked. Verify your password to access your organisation's shared files.",
  isLoading = false
}: {
  prompt?: string;
  isLoading?: boolean;
}) => {
  const session = useSession();
  const [{
    isReady
  }, {
    getAllKeys
  }] = useKeys();
  const [error, setError] = useState("");
  const handlePasswordSubmit = async ({
    password
  }: {
    password: string;
  }) => {
    const res = await getAllKeys({
      password
    });
    console.log(res.error);
    if (res.error) {
      setError("message" in res.error ? res.error.message : "Your password is invalid. Please try again.");
    }
  };
  const handleLogout = async () => {
    await supabase.auth.signOut();
  };

  // Keys are read from sessionStorage on mount. Showing the prompt now would flash the lock
  // screen on every page load.
  if (!isReady) {
    return <div className="w-full space-y-4 p-8" aria-busy="true" aria-label="Checking secure files">
        {Array.from({
        length: 4
      }).map((_, idx) => <Skeleton active key={idx} />)}
      </div>;
  }
  return <>
      <div className="relative flex h-full w-full items-center justify-center">
        <div className="absolute top-0 -z-10 w-full overflow-hidden opacity-50 blur-sm">
          {Array.from({
          length: 4
        }).map((_, idx) => <Skeleton active key={idx} />)}
        </div>
        <div className="mx-auto my-0 mt-[128px] w-full max-w-lg rounded-2xl border border-gray-200 bg-gray-50 p-8 shadow-xl">
          <div className="mx-auto my-0 mb-4 flex h-16 w-16 items-center justify-center rounded-xl border border-gray-200 bg-surface text-gray-900 shadow-lg shadow-gray-200">
            <LockOutlined className="text-2xl" data-sentry-element="LockOutlined" data-sentry-source-file="UserPasswordInput.tsx" />
          </div>
          <div className="mb-4 text-center text-base leading-relaxed">{prompt}</div>

          <Form layout="vertical" requiredMark={false} onFinish={handlePasswordSubmit} onBlur={() => setError("")} data-sentry-element="Form" data-sentry-source-file="UserPasswordInput.tsx">
            <UsernameField email={session?.user.email} variant="chip" data-sentry-element="UsernameField" data-sentry-source-file="UserPasswordInput.tsx" />

            <Form.Item name="password" rules={[{
            required: true,
            message: "Password is required"
          }]} className="mb-6" data-sentry-element="unknown" data-sentry-source-file="UserPasswordInput.tsx">
              <Input.Password prefix={<LockOutlined />} placeholder="Password" title="password" type="password" autoComplete="current-password" data-sentry-element="unknown" data-sentry-source-file="UserPasswordInput.tsx" />
            </Form.Item>

            {error && <div className="mb-4 text-center text-red-500">{error}</div>}

            <Form.Item className="mb-2" data-sentry-element="unknown" data-sentry-source-file="UserPasswordInput.tsx">
              <Button type="primary" block htmlType="submit" loading={isLoading} icon={<UnlockOutlined />} data-sentry-element="Button" data-sentry-source-file="UserPasswordInput.tsx">
                Unlock
              </Button>
            </Form.Item>
            <Form.Item className="mb-2" data-sentry-element="unknown" data-sentry-source-file="UserPasswordInput.tsx">
              <Button type="text" block onClick={handleLogout} data-sentry-element="Button" data-sentry-source-file="UserPasswordInput.tsx">
                Log out
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </>;
};
export default UserPasswordInput;